import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Container } from "@material-ui/core";

import useStyles from "./styles";

import GuinsooLabSecurity from "../../images/guinsoolab-security.svg";
import { ArrowRightAlt } from "@material-ui/icons";


export default function Security() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Grid container className={classes.fg}>
        <Grid item xs={6} className={classes.leftPart}>
          <p className={classes.capital}>Venus Security</p>
          <p className={classes.title}>Megaauth</p>
          <span className={classes.content}>
            Users authenticate with Megaauth rather than individual applications.
          </span>
          <span className={classes.content}>
            Data Asset Identity and Access Management.
          </span>
          <Button
            endIcon={<ArrowRightAlt />}
            color={"primary"}
            disableElevation
            variant={"contained"}
            onClick={() => window.open("https://megaauth.data.labillion.cn", "_blank")}
            style={{textTransform: "Capitalize", borderRadius: 0, marginTop: 50,}}
          >
            Start For Free
          </Button>
        </Grid>

        <Grid item xs={6} className={classes.rightPart}>
          <img src={GuinsooLabSecurity} alt="security" />
        </Grid>
      </Grid>
    </Container>
  );
}